// http-interceptors/client-side.interceptor.ts
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { Observable, catchError, throwError, EMPTY } from 'rxjs';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';

@Injectable()
export class ClientSideHttpInterceptor implements HttpInterceptor {
  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: Object,
    private readonly userService: UserService,
    private readonly router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Block all requests during SSR
    if (!isPlatformBrowser(this.platformId)) {
      return EMPTY;
    }

    // Clone request and add auth header
    let authReq = req;
    const token = this.userService.getToken();
    
    if (token) {
      authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    // Handle response errors
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.handleUnauthorized();
        }
        return throwError(() => error);
      })
    );
  }

  private handleUnauthorized(): void {
    this.userService.logout();
    const currentUrl = window.location.pathname + window.location.search;
    this.router.navigate(['/login'], {
      queryParams: { 
        sessionExpired: true,
        redirect: currentUrl
      }
    });
  }
}